import {articlesAPI} from "../api/api";

const SET_RELEASES = 'SET_RELEASES';
const TOGGLE_IS_FETCHING = 'TOGGLE_IS_FETCHING';



let initialState = {
    releases: {
        'items': [],
        'journal': ''
    },
    isFetching: true
};

const releasesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_RELEASES: {
            return {...state, releases: action.releases}
        }
        case TOGGLE_IS_FETCHING: {
            return {...state, isFetching: action.isFetching}
        }
        default:
            return state;
    }
}



export const setReleases = (releases) => ({type: SET_RELEASES, releases});
export const toggleIsFetching = (isFetching) => ({type: TOGGLE_IS_FETCHING, isFetching});

export const requestReleases = (id) =>{
    return async (dispatch) => {
        dispatch(toggleIsFetching(true));
        let data = await articlesAPI.getReleases(id);
        dispatch(toggleIsFetching(false));
        // Свежие выпуски — первыми: обычно ищут последний номер, а не 2019 год.
        const items = Array.isArray(data.items)
            ? [...data.items].sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')))
            : data.items;
        dispatch(setReleases({...data, items}));
    }
}

export default releasesReducer
